import { render, staticRenderFns } from "./consent-account-info-tab.vue?vue&type=template&id=4388af86&scoped=true"
import script from "./consent-account-info-tab.vue?vue&type=script&lang=js"
export * from "./consent-account-info-tab.vue?vue&type=script&lang=js"
import style0 from "./consent-account-info-tab.vue?vue&type=style&index=0&id=4388af86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4388af86",
  null
  
)

export default component.exports